var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndEventNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2048,
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.9192384 1032.7309c-4.2978937-.032-8.3299308 3.2262-9.2342206 7.4235-.87217511 3.6869.6894335 7.7995 3.8170658 9.9489 3.0357909 2.1743 7.3623574 2.3447 10.5202574.3253 3.175346-1.9445 5.045219-5.8275 4.452721-9.5224-.542558-3.8302-3.602196-7.1614-7.401634-7.9487-.706394-.1576-1.430602-.2314-2.1541896-.2266zm.2282106 2.9961c3.158138-.01 6.059137 2.6037 6.381032 5.7478.410891 3.0052-1.526597 6.1488-4.439527 7.0523-2.8430822.9675-6.2713643-.2672-7.7524839-2.9044-1.6388618-2.7361-.941568-6.6351 1.6554017-8.5347 1.1777062-.9087 2.668674-1.3952 4.1555772-1.361z",
    transform: "matrix(96.752895 0 0 96.752895 55.328158 -99820.70216999998)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndEventNone);
export default __webpack_public_path__ + "static/media/end-event-none.3a851fd24e6bc00c863019f222f30038.svg";
export { ForwardRef as ReactComponent };